import { connect } from 'react-redux'
import Navigation from './navigation'
import { getFetchRequest } from '../../../../stores/assessment-file/assessment-file.selectors'
import { getFetchRequest as getFetchWorksRequest } from '../../../../stores/works/works.selectors'

const mapStateToProps = (state, { match }) => {
  const fetchRequest = getFetchRequest(state)
  const fetchWorksRequest = getFetchWorksRequest(state)
  return {
    ready: !fetchRequest.pending || !fetchWorksRequest.pending
  }
}

export default connect(
  mapStateToProps,
  null
)(Navigation)
